import { ErrorMessage } from 'formik';
import React, { Component } from 'react';
import Input from '../../../../components/Input/input.component';
import { numberMask } from '../../../../components/Input/Masks';
import Required from '../../../../components/Required/required.component';
import SelectMulti from '../../../../components/SelectMulti/selectmulti.component';
import estoqueService from '../../../../services/estoqueService';
import { DevolucaoValidationSchema } from '../editarHistoricoDACA.modal.validates';

export default class ModalEditarHistoricoDacaDevolucao extends Component {
	constructor(props) {
		super(props);
		this.state = {
			estoques: [],
			estoqueSelecionado: {
				origemEstoque: {
					nomeTipoEstoque: '--',
					quantidadeDisponivel: '--',
				},
				quantidadeEmprestada: '--',
			},
			qtdOriginal: '',
			idEmprestimoOriginal: '',
			idDestinoOriginal: '',
		};
	}

	async componentDidMount() {
		const { idDaca, handleValidationSchema, transacao } = this.props;
		const estoqueOrigemResponse = await estoqueService
			.findDestinoEmprestimoByIdDacaForEdit(idDaca, transacao.idHistoricoEmprestimoDevolucao);
		this.setState({ estoques: estoqueOrigemResponse.data });
		handleValidationSchema(DevolucaoValidationSchema);

		const estoque = estoqueOrigemResponse.data
			.filter(item => item.id === transacao.idHistoricoEmprestimoDevolucao)[0];
		this.setState({
			estoqueSelecionado: estoque,
			qtdOriginal: transacao.quantidadeEntradaSaida,
			idEmprestimoOriginal: transacao.idHistoricoEmprestimoDevolucao,
			idDestinoOriginal: transacao.destinoEstoque.id,
		});
	}

	render() {
		const {
			props: {
				transacao,
				handleChange,
				setFieldValue,
			},
			state: {
				estoques,
				estoqueSelecionado,
				qtdOriginal,
				idEmprestimoOriginal,
				idDestinoOriginal,
			},
		} = this;
		return (
			<React.Fragment>
				<div>
					<div className='row'>
						<div className='col-12'>
							<p><strong>Item:</strong> {transacao.daca.nome}</p>
						</div>
						<div className='col-md-6 form-group'>
							<label>
									Origem: <Required />
							</label>
							<SelectMulti
								label='destinoEmprestimo'
								name='idHistoricoEmprestimoDevolucao'
								className='form-control form-control-sm'
								onChange={(e) => {
									setFieldValue('idHistoricoEmprestimoDevolucao', e.value);
									if (e.value) {
										const estoque = estoques
											.filter(item => item.id === e.value)[0];
										this.setState({
											estoqueSelecionado: estoque,
										});
									} else {
										this.setState({
											estoqueSelecionado: {
												origemEstoque: {
													nomeTipoEstoque: '--',
													quantidadeDisponivel: '--',
												},
												quantidadeEmprestada: '--',
											},
										});
									}
								}}
								value={estoqueSelecionado}
								options={estoques}
							/>
							<ErrorMessage
								name='idHistoricoEmprestimoDevolucao'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
						<div className='col-md-6 form-group'>
							<label>
									Destino:
							</label>
							<div className='col pl-0 pr-0'>
								<label>
									{estoqueSelecionado.origemEstoque.nomeTipoEstoque}
								</label>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6'>
							<label>Saldo da origem:</label>
							<div className='col pl-0 pr-0'>
								<label>
									{ idEmprestimoOriginal.toString() === transacao.idHistoricoEmprestimoDevolucao.toString()
										? estoqueSelecionado.quantidadeEmprestada + qtdOriginal : estoqueSelecionado.quantidadeEmprestada}
								</label>

							</div>
						</div>
						<div className='col-md-6'>
							<label>Saldo do destino:</label>
							<div className='col pl-0 pr-0'>
								<label>
									{idDestinoOriginal === estoqueSelecionado.origemEstoque.id
										? transacao.quantidadeAnteriorDestino : estoqueSelecionado.origemEstoque.quantidadeDisponivel}
								</label>
							</div>
						</div>
					</div>

					<div className='row'>
						<div className='col-md-12 form-group'>
							<label>
									Quantidade: <Required />
							</label>
							<Input
								maxLength='18'
								name='quantidadeEntradaSaida'
								type='text'
								mask={numberMask}
								bsSize='sm'
								onChange={handleChange}
								value={transacao.quantidadeEntradaSaida}
							/>
							<ErrorMessage
								name='quantidadeEntradaSaida'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
